import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig} from 'primeng/api';

@Component({
  selector: 'app-imprimir-os-dialog',
  templateUrl: './imprimir-os-dialog.component.html',
  styleUrls: ['./imprimir-os-dialog.component.css']
})
export class ImprimirOsDialogComponent implements OnInit {

  public url;

  constructor(public config: DynamicDialogConfig) { }

  ngOnInit() {

    const embed = document.getElementById('imprimirOs');
    embed.setAttribute('src', this.config.data);

    this.config.showHeader = true;
    this.config.contentStyle = { 'height': '100%' };
    this.config.closable = true;
  }

}
